import { TextInput } from '@carbon/react';
import classNames from 'classnames';
import { Unit } from '../types';
import styles from './unit-list.module.scss';
import { useState } from 'react';
import { TiaCard } from './tia-card';
import { PolygonSvg } from 'components/polygon-svg';
import { DECIMAL_FORMATTER_TWO_FRACTIONS } from 'lib/ui';
import { formatUnitAgreementType } from 'components/allocation-manager/utils';
import { isNil } from 'lodash-es';

export const UnitList = ({
  units,
  selectedUnitId,
  setSelectedUnitId,
}: {
  units: Unit[];
  selectedUnitId: string | undefined;
  setSelectedUnitId: (unitId: string) => void;
}) => {
  const [query, setQuery] = useState('');
  const filteredUnits = units.filter((unit) =>
    unit.name.toLowerCase().includes(query.toLowerCase())
  );
  return (
    <div className={styles.container}>
      <div className={styles.stickyHeader}>
        <h4 className={styles.title}>Units ({units.length}) </h4>
        <TextInput
          id="tract-creation-unit-search"
          labelText=""
          placeholder="Search"
          size="sm"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className={styles.searchInput}
        />
      </div>
      <div className={styles.scrollableContent}>
        {filteredUnits.map((unit, index) => {
          const fields = [
            { key: 'Type', value: unit.type ? unit.type : '--' },
            // Beside Type because both classify the unit — one by development
            // type, one by agreement. Shares the label mapping with the unit
            // page and the certification page so the three cannot disagree
            // about what 'd_and_s' is called.
            {
              key: 'Unit Agreement Type',
              value: formatUnitAgreementType(unit.unitAgreementType),
            },
            { key: 'Area', value: unit.areaAc ? `${unit.areaAc} ac` : '--' },
            {
              key: 'Unit to Subtract %',
              value: unit.unitToSubtractPct
                ? `${DECIMAL_FORMATTER_TWO_FRACTIONS.format(
                    unit.unitToSubtractPct
                  )}%`
                : '--',
            },
            { key: 'Source', value: unit.source ? unit.source : '--' },
            {
              key: 'Subtract to Unit%',
              value: unit.subtractToUnitPct
                ? `${DECIMAL_FORMATTER_TWO_FRACTIONS.format(
                    unit.subtractToUnitPct
                  )}%`
                : '--',
            },
            {
              key: 'LTD Capable',
              value: isNil(unit.ltdCapable)
                ? '--'
                : unit.ltdCapable
                  ? 'Yes'
                  : 'No',
            },
          ];

          return (
            <div
              key={unit.id || index}
              className={classNames(styles.cardContainer, {
                [styles.selected]: unit.id === selectedUnitId,
              })}
              onClick={() => setSelectedUnitId(unit.id)}
            >
              <TiaCard
                fields={fields}
                title={
                  <>
                    {unit.name}
                    {unit.pdpCount !== undefined && unit.pdpCount > 0 && (
                      <span className={styles.pdpCount}>
                        {' '}
                        ({unit.pdpCount} PDP)
                      </span>
                    )}
                  </>
                }
                titleHref={unit.href}
                rightPanel={
                  unit.geometry ? (
                    <PolygonSvg polygon={{ polygon: unit.geometry }} />
                  ) : null
                }
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
